export function parseQueryString() {
  const search = window.location.search;

  const params = new URLSearchParams(search);

  const result: Record<string, any> = {};

  params.forEach((v, key) => {
    result[key] = v;
  });

  return result;
}
